import { graphql } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';
import idx from 'idx';

const query = gql`
  query canMakePhoneCalls {
    me {
      uuid
      permissions {
        canMakePhoneCalls
      }
    }
  }
`;

export const withPhoneCallPermissions = graphql(query, {
  props: ({ data }) => ({
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    dataLoading: data.loading,
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    canMakePhoneCalls: idx(data, (_) => _.me.permissions.canMakePhoneCalls),
  }),
});
